import React from 'react';

import {
  ListingSearchRoomInterface,
  ListingSearchRoomItemProps,
} from '@components/ui/search/SearchGuest/ListingSearchGuestInterface';
import ListingSearchGuestItem from '@components/ui/search/SearchGuest/SearchGuestItem';
import {
  ResponsiveRoomMain,
  StyledListingGuestRoom,
} from '@components/views/hotel/listing/components/ResponsiveSearch/ResponsiveListingSearchStyle';
import { PACKAGE_MAX_AGE } from '@components/views/package/detail/components/package-search-bar/SearchBarInterface';

interface ResponsiveRoomInterface {
  elementRef: React.RefObject<HTMLDivElement> | null | undefined;
  rooms?: Array<ListingSearchRoomInterface>;
  min?: number;
}

const ResponsiveListingRoom = (
  props: ListingSearchRoomInterface &
    ListingSearchRoomItemProps &
    ResponsiveRoomInterface
) => {
  const {
    childGuestCount,
    adultGuestCount,
    childrenList,
    handleChildNumberIncrement,
    handleChildNumberDecrement,
    handleAdultNumberIncrement,
    handleAdultNumberDecrement,
    changeChildAge,
    elementRef,
    min,
  } = props;

  return (
    <StyledListingGuestRoom ref={elementRef}>
      <ResponsiveRoomMain>
        <ListingSearchGuestItem
          title='Yetişkin'
          subTitle='12+ Yaş'
          handleDecrement={handleAdultNumberDecrement}
          handleIncrement={handleAdultNumberIncrement}
          count={adultGuestCount}
          min={min}
        />

        <ListingSearchGuestItem
          title='Çocuk'
          subTitle='0-12 Yaş'
          handleDecrement={handleChildNumberDecrement}
          handleIncrement={handleChildNumberIncrement}
          count={childGuestCount}
          isChildCounter={true}
          childrenList={childrenList}
          changeChildAge={changeChildAge}
          maxAge={PACKAGE_MAX_AGE}
        />
      </ResponsiveRoomMain>
    </StyledListingGuestRoom>
  );
};

export default React.memo(ResponsiveListingRoom);
